import React, { useEffect, useRef, useState } from "react";
import { minutesToHHMM } from "../../../../Utilitie";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import {
  FaRegSquareMinus,
  FaRegSquarePlus,
  FaSquarePlus,
} from "react-icons/fa6";
import { AiOutlineEnter } from "react-icons/ai";
import { FiCornerDownRight } from "react-icons/fi";
const sr = ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"];
const MachineEngTable = ({ data, from }) => {
  const [extraRowCount, setExtraRowCount] = useState(0);
  const [showAll, setShowAll] = useState(false);
  const [activeAsset, setActiveAsset] = useState({});
  useEffect(() => {
    let initialState = {};

    if (showAll) {
      data?.data?.map((obj) => {
        return (initialState = {
          ...initialState,
          [`${obj.DEPARTMENT}__${obj.TYPE}_${obj.ASSET}`]: true,
        });
      });
    } else {
      data?.data?.map((obj) => {
        return (initialState = {
          ...initialState,
          [`${obj.DEPARTMENT}__${obj.TYPE}_${obj.ASSET}`]: false,
        });
      });
    }
    setActiveAsset(initialState);
  }, [showAll]);

  const tableRef = useRef();
  const tableHead =
    from === "custom"
      ? [
          "SR",
          "Department",
          "Type",
          "Machine",
          "Demanded",
          "Granted",
          "Availed",
          // "Not Availed",
          "Demanded Hrs",
          "Granted Hrs",
          "Availed Hrs",
          // "Not Availed Hrs",
          // "Effective Hts",
          "Stipulated Progress",
          "Actual Progress",
          "Shortfall in Progress",
        ]
      : [
          "SR",
          "Type of Machine",
          "No. of Blocks Demanded",
          "No. of Blocks Granted",
          "Hours of Blocks Demanded",
          "Hours of Blocks Granted",
          "Stipulated Progress",
          "Actual Progress",
          "Shortfall in Progress",
        ];

  // 1. Preprocess data to compute row spans
  const computeRowSpans = (rows) => {
    const map = new Map();

    rows.forEach((row, index) => {
      const key = `${row.DEPARTMENT}__${row.TYPE}`;
      if (!map.has(key)) {
        map.set(key, { count: 0, indices: [] });
      }
      const entry = map.get(key);
      activeAsset &&
        Object.entries(activeAsset).map(([key, value]) => {
          if (value && `${row.DEPARTMENT}__${row.TYPE}_${row.ASSET}` === key) {
            const tempCount = data.aDWise.filter(
              (o) => `${o.DEPARTMENT}__${o.TYPE}_${o.ASSET}` === key,
            ).length;
            entry.count += tempCount;
          }
        });
      entry.count += 1;
      entry.indices.push(index);
    });

    return map;
  };

  useEffect(() => {
    // setExtraRowCount(rowcount);
  }, [activeAsset]);
  const rowSpanMap =
    from === "custom" && data?.data ? computeRowSpans(data.data) : null;
  return (
    <div className="papaDiv">
      <div className="row  ">
        <div className="bg-dark text-white m-1 p-1 ">
          <h5 className="p-1 mb-1">
            Details of Machine Progress
            {/* from {data?.from} to {data?.to} */}
          </h5>
        </div>
        <div className="table-responsive">
          <table
            className="table table-hover table-striped"
            ref={tableRef}
            style={{
              tableLayout: "fixed",
              width: "100%",
            }}
          >
            <thead className="table-dark">
              <tr>
                {tableHead.map((head, key) => (
                  <th
                    className="text-wrap"
                    colSpan={head === "Machine" ? 2 : 1}
                    key={key}
                  >
                    {head === "Availed Hrs" ? (
                      <>
                        {head}
                        <br />{" "}
                        <b className="text-secondary"> (-ready time)</b>{" "}
                      </>
                    ) : head === "Machine" ? (
                      <div>
                        <div
                          className=" d-flex align-items-center "
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setShowAll(!showAll);
                          }}
                        >
                          {" "}
                          {showAll ? (
                            <FaRegSquareMinus />
                          ) : (
                            <FaSquarePlus />
                          )}{" "}
                          {head}
                        </div>
                      </div>
                    ) : (
                      head
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody style={{ fontSize: "13px" }}>
              {data.data &&
                data.data.map((obj, key) => {
                  let renderDept = null;
                  let renderType = null;

                  if (from === "custom") {
                    const mapKey = `${obj.DEPARTMENT}__${obj.TYPE}`;
                    const spanInfo = rowSpanMap.get(mapKey);
                    let rowcount = 0;

                    if (spanInfo.indices[0] === key) {
                      renderDept = (
                        <td
                          className="align-middle"
                          rowSpan={spanInfo.count + rowcount}
                        >
                          <b> {obj.DEPARTMENT}</b>
                        </td>
                      );
                      renderType = (
                        <td
                          className="align-middle"
                          rowSpan={spanInfo.count + rowcount}
                        >
                          <b>{obj.TYPE}</b>
                        </td>
                      );
                    }
                  }
                  return (
                    <React.Fragment>
                      <tr
                        className=""
                        style={{ cursor: "pointer" }}
                        key={key}
                        onClick={() => {
                          from === "custom" &&
                            setActiveAsset({
                              ...activeAsset,
                              [`${obj.DEPARTMENT}__${obj.TYPE}_${obj.ASSET}`]:
                                activeAsset[
                                  `${obj.DEPARTMENT}__${obj.TYPE}_${obj.ASSET}`
                                ]
                                  ? false
                                  : true,
                            });
                        }}
                      >
                        <td>{key + 1}</td>
                        {from === "custom" && renderDept}
                        {from === "custom" && renderType}
                        <td className="">
                          {activeAsset[
                            `${obj.DEPARTMENT}__${obj.TYPE}_${obj.ASSET}`
                          ] ? (
                            <FaRegSquareMinus />
                          ) : (
                            // <AiOutlineEnter
                            //   style={{ transform: "scaleX(-1)" }}
                            // />
                            <FaSquarePlus />
                          )}{" "}
                        </td>
                        <td className="">{obj.ASSET}</td>
                        <td>{obj.No_Of_Blocks_Demanded}</td>
                        <td>{obj.No_Of_Blocks_Granted}</td>
                        <td>{obj.Availed}</td>
                        {/* <td>{obj.Not_Availed}</td> */}
                        <td>
                          {minutesToHHMM(
                            obj.Hours_of_Block_Demanded / 60,
                            true,
                          )}
                        </td>
                        <td>
                          {minutesToHHMM(obj.Hours_of_Block_Granted / 60, true)}
                        </td>
                        <td>
                          {minutesToHHMM(
                            (obj?.Hours_of_Block_Granted -
                              obj.Availed * obj.Machine_ready_time) /
                              60,
                            true,
                          )}
                        </td>
                        {/* <td>
                          {minutesToHHMM(obj?.Not_Availed_Hrs / 60, true)}
                        </td> */}
                        {/* <td>
                          {minutesToHHMM(
                            obj.Hours_of_Block_Demanded / 60,
                            true,
                          )}
                        </td> */}
                        <td>
                          {obj.Stipulated_Progress ||
                          obj.Stipulated_Progress === "0.0000"
                            ? Number(obj.Stipulated_Progress).toFixed(2)
                            : "-"}
                        </td>
                        <td>{obj.Actual_Progress || "-"}</td>
                        <td>{obj.Short_Fall_In_Progress || "-"}</td>
                      </tr>
                      {activeAsset[
                        `${obj.DEPARTMENT}__${obj.TYPE}_${obj.ASSET}`
                      ] &&
                        data.aDWise
                          .filter(
                            (o) =>
                              `${o.DEPARTMENT}__${o.TYPE}_${o.ASSET}` ===
                              `${obj.DEPARTMENT}__${obj.TYPE}_${obj.ASSET}`,
                          )
                          ?.map((ad, k) => {
                            return (
                              <tr className=" table-info">
                                <td></td>
                                <td>
                                  &nbsp;&nbsp;
                                  <FiCornerDownRight className="" />
                                  &nbsp;
                                  {sr[k]}
                                </td>
                                <td className="">{ad.ASSET_DISCRIPTION}</td>
                                <td>{ad.No_Of_Blocks_Demanded}</td>
                                <td>{ad.No_Of_Blocks_Granted}</td>
                                <td>{ad.Availed}</td>
                                {/* <td>{ad.Not_Availed}</td> */}
                                <td>
                                  {minutesToHHMM(
                                    ad.Hours_of_Block_Demanded / 60,
                                    true,
                                  )}
                                </td>
                                <td>
                                  {minutesToHHMM(
                                    ad.Hours_of_Block_Granted / 60,
                                    true,
                                  )}
                                </td>
                                <td>
                                  {" "}
                                  {minutesToHHMM(
                                    (ad?.Hours_of_Block_Granted -
                                      ad.Availed * ad.Machine_ready_time) /
                                      60,
                                    true,
                                  )}
                                </td>
                                {/* <td>
                                  {minutesToHHMM(
                                    ad?.Not_Availed_Hrs / 60,
                                    true,
                                  )}
                                </td> */}

                                <td>
                                  {ad.Stipulated_Progress ||
                                  ad.Stipulated_Progress === "0.0000"
                                    ? Number(ad.Stipulated_Progress).toFixed(2)
                                    : "-"}
                                </td>
                                <td>{ad.Actual_Progress || "-"}</td>
                                <td>{ad.Short_Fall_In_Progress || "-"}</td>
                              </tr>
                            );
                          })}
                    </React.Fragment>
                  );
                })}
            </tbody>
          </table>
        </div>
        <DownloadExcel
          tableRef={tableRef}
          fileName={`Machine (Eng) - ${data?.from}-${data?.to}`}
        />
      </div>
    </div>
  );
};

export default MachineEngTable;
